import React, { useState } from 'react';
import "../../css/teacher/TeacherReports.css";
import { toast, ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import Loader from "../../components/Loader";




function Reports() {
    const [formData, setFormData] = useState({
        reportTitle: '',
        reportType: '',
        urgency: 'medium',
        department: '',
        description: '',
        attachments: [], 
        date: new Date().toISOString().substr(0, 10)
    });

    const [success, setSuccess] = useState(false);
    const [isLoading, setIsLoading] = useState(false);

    const reportTypes = [
        'Student Behavior',
        'Academic Concern',
        'Facility Issue',
        'Resource Request',
        'Event Proposal',
        'Technical Problem',
        'Other'
    ];

    const departments = [
        'Mathematics',
        'Science',
        'English',
        'History',
        'Computer Science',
        'Physical Education',
        'Administration'
    ];

    // Convert file to base64
    const fileToBase64 = (file) => {
        return new Promise((resolve, reject) => {
            const reader = new FileReader();
            reader.readAsDataURL(file);
            reader.onload = () => resolve(reader.result);
            reader.onerror = (error) => reject(error);
        });
    };

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData({
            ...formData,
            [name]: value
        });
    };

    const handleFileChange = async (e) => {
        const files = Array.from(e.target.files);
        try {
            const base64Files = await Promise.all(files.map(file => fileToBase64(file)));
            setFormData({
                ...formData,
                attachments: base64Files
            });
        } catch (error) {
            toast.error("Error processing files.");
        }
    };

    const validateForm = () => {
        if (!formData.reportTitle.trim()) {
            toast.error("Report Title is required.");
            return false;
        }
        if (!formData.reportType) {
            toast.error("Report Type is required.");
            return false;
        }
        if (!formData.description.trim()) {
            toast.error("Description is required.");
            return false;
        }
        return true;
    };

    const handleSubmit = async (isDraft = false) => {
        const token = localStorage.getItem("token");
        if (!token) {
            toast.error("Unauthorized! Please log in again.");
            return;
        }

        if (!validateForm()) {
            return;
        }

        setIsLoading(true);

        try {
            const body = {
                reportTitle: formData.reportTitle,
                reportType: formData.reportType,
                urgency: formData.urgency,
                department: formData.department,
                description: formData.description,
                date: formData.date,
                attachments: formData.attachments // Send base64 strings
            };

            const endpoint = isDraft ? '/save-draft' : '/create';
            const response = await fetch(`https://schoolpro-api.uniums.com/api/teacher/report${endpoint}`, {
                method: 'POST',
                headers: {
                    "Authorization": `Bearer ${token}`,
                    "Content-Type": "application/json"
                },
                body: JSON.stringify(body)
            });

            if (!response.ok) {
                const errorData = await response.json();
                throw new Error(errorData.message || "Failed to submit report");
            }

            const data = await response.json();
            toast.success(data.message);

            setSuccess(true);

            setTimeout(() => {
                setSuccess(false);
                setFormData({
                    reportTitle: '',
                    reportType: '',
                    urgency: 'medium',
                    department: '',
                    description: '',
                    attachments: [],
                    date: new Date().toISOString().substr(0, 10)
                });
            }, 3000);

        } catch (error) {
            console.error("Error submitting report:", error);
            toast.error(`Error: ${error.message}`);
        } finally {
            setIsLoading(false);
        }
    };

    return (
        <div className="teacherReport-container">
            <ToastContainer position="top-right" autoClose={5000} hideProgressBar={false} />
            {isLoading && <Loader />}

            <div className="teacherReport-header">
                <h1>Submit Report to Administration</h1>
                <p>Use this form to report issues, make requests, or provide feedback to the administration</p>
            </div>

            {success ? (
                <div className="teacherReport-success">
                    <div className="teacherReport-success-icon">✓</div>
                    <h2>Report Submitted Successfully!</h2>
                    <p>Your report has been sent to the administration. Thank you for your feedback.</p>
                </div>
            ) : (
                <div className="teacherReport-form">
                    <div className="teacherReport-form-section">
                        <div className="teacherReport-form-row">
                            <div className="teacherReport-form-group">
                                <label htmlFor="reportTitle">Report Title*</label>
                                <input
                                    type="text"
                                    id="reportTitle"
                                    name="reportTitle"
                                    value={formData.reportTitle}
                                    onChange={handleChange}
                                    placeholder="Enter a descriptive title"
                                    className="teacherReport-input"
                                />
                            </div>

                            <div className="teacherReport-form-group">
                                <label htmlFor="date">Date</label>
                                <input
                                    type="date"
                                    id="date"
                                    name="date"
                                    value={formData.date}
                                    onChange={handleChange}
                                    className="teacherReport-input"
                                />
                            </div>
                        </div>

                        <div className="teacherReport-form-row">
                            <div className="teacherReport-form-group">
                                <label htmlFor="reportType">Report Type*</label>
                                <select
                                    id="reportType"
                                    name="reportType"
                                    value={formData.reportType}
                                    onChange={handleChange}
                                    className="teacherReport-select"
                                >
                                    <option value="">Select Report Type</option>
                                    {reportTypes.map((type, index) => (
                                        <option key={index} value={type}>{type}</option>
                                    ))}
                                </select>
                            </div>

                            <div className="teacherReport-form-group">
                                <label htmlFor="department">Department</label>
                                <select
                                    id="department"
                                    name="department"
                                    value={formData.department}
                                    onChange={handleChange}
                                    className="teacherReport-select"
                                >
                                    <option value="">Select Department</option>
                                    {departments.map((dept, index) => (
                                        <option key={index} value={dept}>{dept}</option>
                                    ))}
                                </select>
                            </div>
                        </div>

                        <div className="teacherReport-form-row">
                            <div className="teacherReport-form-group teacherReport-urgency-group">
                                <label>Urgency Level</label>
                                <div className="teacherReport-urgency-options">
                                    <div className="teacherReport-urgency-option">
                                        <input
                                            type="radio"
                                            id="low"
                                            name="urgency"
                                            value="low"
                                            checked={formData.urgency === 'low'}
                                            onChange={handleChange}
                                        />
                                        <label htmlFor="low" className="teacherReport-urgency-label teacherReport-urgency-low">Low</label>
                                    </div>

                                    <div className="teacherReport-urgency-option">
                                        <input
                                            type="radio"
                                            id="medium"
                                            name="urgency"
                                            value="medium"
                                            checked={formData.urgency === 'medium'}
                                            onChange={handleChange}
                                        />
                                        <label htmlFor="medium" className="teacherReport-urgency-label teacherReport-urgency-medium">Medium</label>
                                    </div>

                                    <div className="teacherReport-urgency-option">
                                        <input
                                            type="radio"
                                            id="high"
                                            name="urgency"
                                            value="high"
                                            checked={formData.urgency === 'high'}
                                            onChange={handleChange}
                                        />
                                        <label htmlFor="high" className="teacherReport-urgency-label teacherReport-urgency-high">High</label>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div className="teacherReport-form-section">
                        <h2>Report Content</h2>

                        <div className="teacherReport-form-group">
                            <label htmlFor="description">Description*</label>
                            <textarea
                                id="description"
                                name="description"
                                value={formData.description}
                                onChange={handleChange}
                                placeholder="Provide a detailed description of your report..."
                                rows="5"
                                className="teacherReport-textarea"
                            ></textarea>
                        </div>

                        <

                            div className="teacherReport-form-group">
                            <label>Attachments (Optional)</label>
                            <div className="teacherReport-file-upload">
                                <input
                                    type="file"
                                    id="attachments"
                                    multiple
                                    onChange={handleFileChange}
                                    style={{ display: 'none' }}
                                />
                                <label htmlFor="attachments" className="teacherReport-file-label">
                                    <span className="teacherReport-file-icon">+</span>
                                    <span>Upload Files</span>
                                </label>
                                <span className="teacherReport-file-info">
                                    {formData.attachments.length > 0
                                        ? `${formData.attachments.length} files selected`
                                        : 'No files selected'}
                                </span>
                            </div>
                        </div>
                    </div>

                    <div className="teacherReport-form-actions">
                        <button
                            type="button"
                            className="teacherReport-button teacherReport-button-secondary"
                            onClick={() => handleSubmit(true)}
                            disabled={isLoading}
                        >
                            Save as Draft
                        </button>
                        <button
                            type="button"
                            className="teacherReport-button teacherReport-button-primary"
                            onClick={() => handleSubmit(false)}
                            disabled={isLoading}
                        >
                            Submit Report
                        </button>
                    </div>
                </div>
            )
            }
        </div >
    );
}

export default Reports;